import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Button, Table } from 'reactstrap';
import { useIntl } from 'react-intl';

import AcceptedTermsOfServiceListHeader from './AcceptedTermsOfServiceListHeader';
import AcceptedTermsOfServiceListItem from './AcceptedTermsOfServiceListItem';
import CollectedDetailsFooter from '../ShareDetails/CollectedDetailsFooter';
import Loading from '../../Loading';
import ProcessingSpinner from '../../ProcessingSpinner';

import { downloadCSV } from '../../../helpers/App';
import { handleComponentParams } from '../../../helpers/URLParams';

const TermsOfService = ({
  subtitle,
  entityUuid,
  fetchAcceptedTermsOfService,
  APIfetchAcceptedTermsOfService,
}) => {
  const intl = useIntl();

  const [loading, setLoading] = useState(true);
  const [downloading, setDownloading] = useState(false);
  const [acceptedTermsOfService, setAcceptedTermsOfService] = useState([]);
  const [meta, setMeta] = useState(null);
  const [page, setPage] = useState(1);
  const [perPage] = useState(20);

  useEffect(() => {
    handleComponentParams(
      true,
      ['page'],
      null,
      [setPage],
      () => {},
    );
  }, []);

  useEffect(() => {
    setLoading(true);
    fetchAcceptedTermsOfService(entityUuid, page, perPage).then((response) => {
      setAcceptedTermsOfService(response.data);
      setMeta(response.meta);
      setLoading(false);
    });
  }, [page, perPage, entityUuid, fetchAcceptedTermsOfService]);

  const handleDownloadCSV = () => {
    setDownloading(true);
    APIfetchAcceptedTermsOfService(entityUuid, { csv: true }).then((response) => {
      const fileName = response.headers['content-disposition'] || 'share-accepted-terms.csv';
      return downloadCSV(response.data, fileName);
    }).finally(() => {
      setDownloading(false);
    });
  };

  const handleChangePage = (newPage) => {
    setPage(newPage);
  };

  if (loading) {
    return (
      <div className="tab-content-wrapper">
        <Loading className="gray" />
      </div>
    );
  }

  return (
    <div className="tab-content-wrapper">
      <div className="collected-details-wrapper">
        <div>
          <h4>
            {intl.formatMessage({ defaultMessage: 'Accepted terms of service' })}
          </h4>
          <p>
            {subtitle}
          </p>
        </div>
        <div>
          <Button
            disabled={downloading}
            onClick={handleDownloadCSV}
          >
            <ProcessingSpinner show={downloading} />
            {intl.formatMessage({ defaultMessage: 'Download CSV' })}
          </Button>
        </div>
      </div>
      <div>
        {acceptedTermsOfService && acceptedTermsOfService.length > 0 ? (
          <>
            <div className="table-wrapper">
              <Table className="files-list collected-details-list" responsive>
                <thead>
                  <AcceptedTermsOfServiceListHeader
                    downloading={downloading}
                    handleDownloadCSV={handleDownloadCSV}
                  />
                </thead>
                <tbody>
                  {acceptedTermsOfService.map(element => (
                    <AcceptedTermsOfServiceListItem
                      key={element.uuid}
                      element={element}
                    />
                  ))}
                </tbody>
              </Table>
            </div>
            <CollectedDetailsFooter
              total={meta ? meta.total : 0}
              page={page}
              perPage={perPage}
              handleChangePage={handleChangePage}
            />
          </>
        ) : (
          <div className="nothing-found-wrapper bottom">
            <h3>{intl.formatMessage({ defaultMessage: 'No accepted terms of service' })}</h3>
          </div>
        )}
      </div>
    </div>
  );
};

TermsOfService.propTypes = {
  subtitle: PropTypes.string,
  entityUuid: PropTypes.string.isRequired,
  fetchAcceptedTermsOfService: PropTypes.func.isRequired,
  APIfetchAcceptedTermsOfService: PropTypes.func.isRequired,
};

export default TermsOfService;
